import { useState, useEffect, useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import { Box, Alert, Button, CircularProgress } from '@mui/material'
import SupportHeader from 'src/supportPortal/layout/SupportHeader'
import { getAllProducts } from 'src/supportPortal/services/docSideService'
import ProductSelection from './components/ProductSelection'
import { DocsideCmsContext } from 'src/supportPortal/context/DocsideCmsContextProvider'

export default function DocSideProducts() {
  const navigate = useNavigate()
  const { products, loadingProducts, errorProducts, loadProducts } = useContext(DocsideCmsContext)

  const handleProductSelect = (product) => {
    navigate(`/support-home/doc-side/${product.id}/contexts`)
  }

  return (
    <div className="d-flex flex-column h-100">
      <SupportHeader heading="DocSide" subHeading="Product Management" showBackButton />

      <Box
        sx={{
          flex: 1,
          p: { xs: 2, sm: 3, md: 4 },
          maxWidth: '1400px',
          width: '100%',
          margin: '0 auto',
          background: 'linear-gradient(180deg, rgba(249, 250, 251, 0.5) 0%, rgba(243, 244, 246, 0.3) 100%)',
          minHeight: 'calc(100vh - 80px)',
        }}
      >
        {/* Global Error Alert */}
        {errorProducts && (
          <Alert
            severity="error"
            sx={{
              mb: 3,
              borderRadius: 2,
              boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
            }}
            action={
              <Button
                size="small"
                onClick={() => {
                  loadProducts()
                }}
                sx={{ textTransform: 'none' }}
              >
                Retry
              </Button>
            }
          >
            {errorProducts}
          </Alert>
        )}

        {/* Loading State */}
        {loadingProducts && (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              minHeight: '400px',
            }}
          >
            <CircularProgress />
          </Box>
        )}

        {!loadingProducts && !errorProducts && (
          <ProductSelection
            products={products}
            onProductSelect={handleProductSelect}
            loading={loadingProducts}
          />
        )}
      </Box>
    </div>
  )
} 